<template>
  <div class="main-desktop-tabs">
    <TabsParent
      v-if="parent"
      :parent
    />
    <nav class="main-desktop-tabs__container">
      <TabsArea
        :items
        :disabled
      />
      <slot name="postfix" />
    </nav>
    <div
      data-refid="actionsContainer"
      class="main-desktop-tabs__actions"
    />
    <slot name="actions" />
  </div>
</template>

<script setup lang="ts">

import { NavigationItem, NavigationPreset } from '@types'

import TabsArea from './TabsArea.vue'
import TabsParent from './TabsParent.vue'

type Props = {
  parent?: NavigationPreset,
  items: NavigationItem[],
  disabled?: boolean
}

defineProps<Props>()
</script>

<style scoped>
.main-desktop-tabs {
  @apply relative;
  @apply flex items-center;
  @apply -mx-default px-default;
  @apply border-b border-gray-200 dark:border-gray-600;
  @apply bg-card;

  &__container {
    @apply flex flex-auto;
    @apply px-1;
    @apply overflow-hidden;
  }

  &__actions {
    @apply flex items-center;
    @apply gap-2;

    > *:first-child {
      @apply ml-2.5;
    }
  }
}
</style>
